import { AttachedFile, AiTrainingFile } from '../types'

const BYTES_IN_ONE_KB = 1024
const BYTES_IN_ONE_MB = BYTES_IN_ONE_KB * 1024

const MAX_FILE_SIZES = {
    PDF: 100 * BYTES_IN_ONE_MB, // 100 MB
    JPG: 5 * BYTES_IN_ONE_MB, // 5 MB
    JPEG: 5 * BYTES_IN_ONE_MB, // 5 MB
    PNG: 5 * BYTES_IN_ONE_MB, // 5 MB
    MP4: 16 * BYTES_IN_ONE_MB // 16 MB
} as const

const MAX_TRAINING_FILE_SIZES = {
    PDF: 2 * BYTES_IN_ONE_MB, // 2 MB
    TXT: 40 * BYTES_IN_ONE_KB, // 40 KB
    DOC: 600 * BYTES_IN_ONE_KB, // 600 KB
    DOCX: 400 * BYTES_IN_ONE_KB // 400 KB
} as const

export function validateAttachFile(file: AttachedFile) {
    if (!file) return { valid: true }

    const maxSize = MAX_FILE_SIZES[file.type]

    if (!maxSize) {
        return { valid: false, invalidType: true }
    }

    if (file.size > maxSize) {
        return { valid: false, invalidSize: true }
    }

    return { valid: true }
}

export function validateAiTrainingFile(file: AiTrainingFile) {
    if (!file) return { valid: true }

    const maxSize = MAX_TRAINING_FILE_SIZES[file.type]
    if (!maxSize) {
        return { valid: false, invalidType: true }
    }
    if (file.size > maxSize) {
        return { valid: false, invalidSize: true }
    }
    if (file.error) {
        return { valid: false, emptyFile: true }
    }
    return { valid: true }
}
